<script>
import { make } from 'vuex-pathify'

const state = {
  apiAccreditations: [],
  apiClient: null,
  apiClientBookings: [],
  apiClientCredits: [],
  apiClientTokens: [],
  apiClients: [],
  apiLocations: [],
  apiMixinInitialised: false,
  apiMixinInitialising: false,
  apiNotes: [],
  apiOperator: null,
  apiOperatorUsers: null,
  apiOperators: [],
  apiOperatorsFromApiJson: [],
  apiProfessional: null,
  apiProfessionalBookings: [],
  apiProfessionalSlots: [],
  apiProfessionalTransactionPrices: [],
  apiProfessionals: [],
  apiProfessions: [],
  apiServices: [],
  apiStatusInterval: null,
  apiToken: null,
  apiTokenExpiry: null,
  apiTokenInterval: null,
  apiUserId: null,
  apiVouchers: [],
  zoomAuthorised: null
}

const mutations = make.mutations(state)

const namespaced = true

export default {
  mutations,
  namespaced,
  state
}
</script>
